import { Breadcrumbs, NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { cn } from '@/lib/utils';
import { FC, PropsWithChildren } from 'react';

interface BreadcrumbPageHeaderProps {
  breadcrumbs: NavPage[];
  className?: string;
}

const BreadcrumbPageHeader: FC<PropsWithChildren<BreadcrumbPageHeaderProps>> = ({
  breadcrumbs,
  className,
  children
}) => {
  return (
    <div className={cn('border-secondary-std border-b bg-white bg-opacity-80 px-8 pt-2 pb-5', className)}>
      <div className="flex flex-col w-full">
        <Breadcrumbs pages={breadcrumbs} />
        {children}
      </div>
    </div>
  );
};

export default BreadcrumbPageHeader;
